import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import photos from "../../assets/img/Ellipse 722.png";
import Profilery from "../../assets/img/Profilery.png";
import LanguageSelector from "../Header/LanguageSelector";
import { useTranslation } from "react-i18next";
import { MdOutlinePrivacyTip } from "react-icons/md";
import StickyBottomNav from "../StickyBottomNav/StickyBottomNav";
import GlobeIcon from "../../assets/img/GlobeIcon.png";
import { IoIosArrowForward } from "react-icons/io";
import Rectangle from "../../assets/img/Rectangle.png";
import Call from "../../assets/img/Call.png";
import Password from "../../assets/img/Password.png";
import Buy from "../../assets/img/Buy.png";
import { IoShareSocialOutline } from "react-icons/io5";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const Edit_2 = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // ✅ refs
  const menuRef = useRef(null);
  const languageRef = useRef(null);

  // ✅ Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if clicking inside language selector → do nothing
      if (languageRef.current && languageRef.current.contains(event.target)) {
        return;
      }
      // if clicking outside whole menu → navigate
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        navigate("/");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navigate]);
  // ✅ Get user from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error("Error parsing user JSON:", error);
        setUser(null);
      }
    }
  }, []);

  // ✅ Logout
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    window.location.reload();
    setTimeout(() => {
      navigate("/");
    }, 1000);
  };

  // ✅ Profile image
  const profileImage = user?.avatar
    ? user.avatar || photos
    : `https://api.dicebear.com/7.x/initials/svg?seed=${user?.name?.charAt(0) || "U"
    }`;

  const handleShare = async () => {
    const ANDROID_STORE =
      "https://play.google.com/store/apps/details?id=com.rent.el.in";
    const IOS_STORE =
      "https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463";

    const ua = navigator.userAgent || navigator.vendor || window.opera;

    let targetUrl =
      /android/i.test(ua) ? ANDROID_STORE :
        /iPad|iPhone|iPod/.test(ua) ? IOS_STORE :
          window.location.origin; // desktop → website

    if (navigator.share) {
      try {
        await navigator.share({
          title: "Rentel – Rent Smart, Live Better",
          text: "Hey! 😄 Check out Rentel – an awesome rental app. Download it now 👇",
          url: targetUrl,
        });
        return;
      } catch (err) { }
    }

    // Desktop fallback → open custom share panel
    openShareModal(targetUrl);
  };

  const openShareModal = (url) => {
    const encoded = encodeURIComponent(url);
    window.open(
      `https://api.whatsapp.com/send?text=Hey! Hey! 😄 Check out Rentel – an awesome rental app. Download it now 👇 ${encoded}`,
      "_blank"
    );
  };



  const hideEmailDomain = (email) => {
    if (!email) return "";

    const [namePart, domainPart] = email.split("@");

    // namePart 그대로 રાખો, domain truncate કરો
    const shortDomain = domainPart.length > 5 ? domainPart.slice(0, 0) + "..." : domainPart;

    return `${namePart}@${shortDomain}`;
  };


  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          {/* === Desktop View === */}
          <div className="container desktop-only">
            <div className="profile-container desktop-only" ref={menuRef}>
              <div className="profile-cards">
                <div className="photo-detail">
                  <div className="profnam">
                    <img
                      className="profile-imgee"
                      src={profileImage}
                      alt="Profile"
                    />
                    <div
                      style={{
                        width: "100%",
                        minWidth: 0,          // 🔥 MOST IMPORTANT
                        overflow: "hidden",   // 🔥 parent overflow rokse
                      }}
                    >
                      <h3 className="profile-namee">{user?.name || ""}</h3>

                      <p className="profile-info">
                        {user?.email ? hideEmailDomain(user.email) : ""} |{" "}
                        {user?.phoneNumber || ""}
                      </p>
                    </div>

                  </div>
                </div>

                <button
                  className="edit-btn"
                  onClick={() => navigate("/profile-edit")}
                >
                  {t("edit_profile")}
                </button>

                <div className="menu-section">
                  <p className="menu-item" onClick={() => navigate("/My_ads")}>
                    <img src={Buy} className="passkey" alt="My Ads" />{" "}
                    {t("My_Product")}
                  </p>
                  <p
                    className="menu-item"
                    onClick={() => navigate("/Password")}
                  >
                    <img
                      src={Password}
                      className="passkey"
                      alt="Change Password"
                    />{" "}
                    {t("change_password")}
                  </p>
                  <p
                    className="menu-item"
                    onClick={() => navigate("/Contact_Us")}
                  >
                    <img src={Call} className="passkey" alt="Contact Us" />{" "}
                    {t("contact_us")}
                  </p>
                  <p
                    className="menu-item"
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <img
                      src={Password}
                      className="passkey"
                      alt="Privacy Policy"
                    />{" "}
                    {t("privacy_policy")}
                  </p>

                  {/* ✅ Wrap LanguageSelector with ref */}
                  <div className="language-in-profile" ref={languageRef}>
                    <LanguageSelector />
                  </div>
                </div>

                <button className="logout-btn" onClick={handleLogout}>
                  {t("logout")}
                </button>
              </div>
            </div>
          </div>

          {/* === Mobile View === */}
          <div className="profile-container mobile-onlyss">
            <div className="profile-header-wrapper">
              <img className="profile-header-bg" src={Rectangle} alt="bg" />

              <div className="profile-header-content">
                <h2 className="profile-title">Profile</h2>
                <div className="name-pro-emi">
                  <img
                    className="profile-pic"
                    src={
                      user?.avatar
                        ? user.avatar
                        : `https://api.dicebear.com/7.x/initials/svg?seed=${user?.name?.charAt(0) || "U"
                        }`
                    }
                    alt="profile"
                  />
                  <h3 className="profile-name">{user?.name || "User Name"}</h3>
                  <p className="profile-contact">
                    {user?.email} | {user?.phoneNumber}
                  </p>
                </div>
              </div>
            </div>

            <div className="profile-cards-wrapper" ref={menuRef}>
              <div className="profile-card-mobile">
                {user && (
                  <div className="containall-mobile">
                    <div
                      className="menu-item-mobile"
                      onClick={() => navigate("/profile-edit")}
                    >
                      <div className="icon-circlef">
                        <img
                          src={Profilery}
                          className="passkey"
                          alt="Edit Profile"
                        />
                      </div>
                      {t("edit_profile")}
                    </div>
                    <IoIosArrowForward />
                  </div>
                )}

                {/* ✅ Language option with ref */}
                <div className="language-mobile" ref={languageRef}>
                  <div className="menu-item-mobile">
                    <div className="icon-circlef">
                      <img src={GlobeIcon} className="passkey" alt="Language" />
                    </div>
                    {t("language")}
                  </div>
                  <LanguageSelector />
                </div>
              </div>

              <div className="profile-card-mobile">
                <div className="containall-mobile">
                  <div
                    className="menu-item-mobile"
                    onClick={() => navigate("/Password")}
                  >
                    <div className="icon-circlef">
                      <img
                        src={Password}
                        className="passkey"
                        alt="Change Password"
                      />
                    </div>
                    {t("change_password")}
                  </div>
                  <IoIosArrowForward />
                </div>

                <div className="containall-mobile">
                  <div
                    className="menu-item-mobile"
                    onClick={() => navigate("/Contact_Us")}
                  >
                    <div className="icon-circlef">
                      <img src={Call} className="passkey" alt="Contact Us" />
                    </div>
                    {t("contact_us")}
                  </div>
                  <IoIosArrowForward />
                </div>

                <div className="containall-mobile">
                  <div
                    className="menu-item-mobile"
                    onClick={() =>
                      window.open("https://rentel.in/privacy-policy", "_blank")
                    }
                  >
                    <div className="icon-circlef">
                      <MdOutlinePrivacyTip size={24} color="#18154B" />
                    </div>
                    {t("privacy_policy")}
                  </div>
                  <IoIosArrowForward />
                </div>

                <div className="containall-mobile">
                  <div className="menu-item-mobile" onClick={handleShare}>
                    <div className="icon-circlef">
                      <IoShareSocialOutline size={24} color="#18154B" />
                    </div>
                    {t("share_with_friends")}
                  </div>
                  <IoIosArrowForward />
                </div>
              </div>

              {user && (
                <button className="logout-btn-mobile" onClick={handleLogout}>
                  {t("logout")}
                </button>
              )}
            </div>
          </div>

          <StickyBottomNav />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Edit_2;
